export const parseGoogleAddress = (components: google.maps.GeocoderAddressComponent[]) => {
  const result = {
    route: '',
    streetNumber: '',
    city: '',
    province: '',
    postalCode: '',
    country: '',
    countryCode: '',
  };

  for (const comp of components) {
    const types = comp.types;
    if (types.includes('route')) result.route = comp.long_name;
    if (types.includes('street_number')) result.streetNumber = comp.long_name;
    if (types.includes('postal_code')) result.postalCode = comp.long_name;
    if (types.includes('country')) {
      result.country = comp.long_name;
      result.countryCode = comp.short_name;
    }
    if (
      types.includes('locality') ||
      types.includes('postal_town') ||
      types.includes('sublocality') ||
      types.includes('administrative_area_level_3')
    ) {
      result.city = comp.long_name;
    }
    if (types.includes('administrative_area_level_2')) {
      result.province = comp.long_name;
    } else if (types.includes('administrative_area_level_1') && !result.province) {
      result.province = comp.long_name;
    }
  }

  return result;
};
